import React from 'react';
export const AddButtonWrapperSkeleton = () => (React.createElement("div", { className: "skeleton mt:16 mt:20:xl-up w:100p h:64 h:96:xl-up" }));
